import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

import ThanksSentAlert from "./thanks_sent_alert";

// 使われていない
export default createReactClass({
  displayName: "Root",
  propTypes: {
    thanksTargetUsers: PropTypes.array.isRequired,
    isThanksTargetUsersEnabled: PropTypes.object.isRequired,
    eventId: PropTypes.number,
    circleId: PropTypes.number,
  },
  getInitialState() {
    return {
      isThanksTargetUsersEnabled: {},
      isSendingThanks: false,
      selectedUserId: 0,
    };
  },
  componentDidMount() {
    $(".btn-thanks").on("click", function() {
      $(".btn-thanks-comment").show();
      $(".thanks-comment-form").hide();
      $(".thanks-textarea").val("");
    });
    this.setState({
      isThanksTargetUsersEnabled: this.props.isThanksTargetUsersEnabled,
    });
  },
  sendThanksToServer() {
    this.setState({
      isSendingThanks: true,
    });
    $.ajax({
      url: "/api/thank/send_thank",
      type: "post",
      cache: false,
      data: {
        user_id: this.state.selectedUserId,
        event_id: this.props.eventId,
        circle_id: this.props.circleId,
      },
      success: function() {
        var newIsThanksTargetUsersEnabled = this.state
          .isThanksTargetUsersEnabled;
        newIsThanksTargetUsersEnabled[
          this.state.selectedUserId.toString()
        ] = false;
        this.setState({
          isThanksTargetUsersEnabled: newIsThanksTargetUsersEnabled,
          isSendingThanks: false,
        });
      }.bind(this),
      error: function() {
        this.setState({
          isSendingThanks: false,
        });
      }.bind(this),
    });
  },
  handleThanksButton(e) {
    this.setState(
      {
        selectedUserId: parseInt(e.target.value),
      },
      function() {
        this.sendThanksToServer();
      }
    );
  },
  fullname_disp(user){
    if (user.is_fullname_hidden && user.is_verified_identity){
      return `@${user.tunagate_id}(本人確認済)`;
    }
    else if (!user.is_fullname_hidden && user.is_verified_identity){
      return  `${user.familyname} ${user.firstname}(本人確認済)`
    }
    else{
      return `${user.familyname} ${user.firstname}`
    }
  },
  render() {
    var targetUserList = this.props.thanksTargetUsers.map(
      function(item) {
        return (
          <tr key={item.id}>
            <td className="g-pt-15 g-pb-15">
              {this.fullname_disp(item)}{" "}
              <a href={"/member/profile/" + item.member_id}>
                @{item.tunagate_id}
              </a>
            </td>
            <td className="g-pt-15 g-pb-15">
              <button
                className="btn u-btn-pink btn-xs btn-thanks"
                data-toggle="modal"
                data-target="#thanks-comment-btn"
                disabled={!this.state.isThanksTargetUsersEnabled[item.id]}
                onClick={this.handleThanksButton}
                value={item.id}
              >
                <i className="fas fa-heart" /> ありがとう！
              </button>
            </td>
          </tr>
        );
      }.bind(this)
    );

    return (
      <div>
        <button
          className="btn u-btn-pink btn-md"
          style={{ width: "100%", margin: "10px 0 5px" }}
          data-toggle="modal"
          data-target="#thanks-btn"
        >
          <i className="fas fa-heart" /> ありがとう！
        </button>
        <div
          className="modal fade"
          id="thanks-btn"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="loginLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header" style={{ borderBottom: "none" }}>
                <button type="button" className="close" data-dismiss="modal">
                  <span aria-hidden="true">×</span>
                  <span className="sr-only">Close</span>
                </button>
                <h4 className="modal-title" id="loginLabel">
                  「ありがとう！」を贈ろう！
                </h4>
              </div>
              <div className="modal-body">
                <table className="table g-mb-0">
                  <tbody>{targetUserList}</tbody>
                </table>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  data-dismiss="modal"
                  className="close btn btn-xs btn-default"
                  style={{ fontSize: "14px", color: "#333333" }}
                >
                  &nbsp;閉じる&nbsp;
                </button>
              </div>
            </div>
          </div>
        </div>
        <ThanksSentAlert
          isSendingThanks={this.state.isSendingThanks}
          selectedUserId={this.state.selectedUserId}
          eventId={this.props.eventId}
          circleId={this.props.circleId}
        />
      </div>
    );
  },
});
